import type { contractBook } from "@eulerxyz/core-sdk"
import type { Address, ContractFunctionName, Hex } from "viem"
import type { ContractFunctionResult } from "../evc"

export enum OracleNameFunction {
  ChainlinkOracle = "getChainlinkOracleInfo",
  ChainlinkInfrequentOracle = "getChainlinkInfrequentOracleInfo",
  ChronicleOracle = "getChronicleOracleInfo",
  LidoOracle = "getLidoOracleInfo",
  LidoFundamentalOracle = "getLidoFundamentalOracleInfo",
  PythOracle = "getPythOracleInfo",
  RedstoneCoreOracle = "getRedstoneCoreOracleInfo",
  UniswapV3Oracle = "getUniswapV3OracleInfo",
  CrossAdapter = "getCrossAdapterInfo",
  EulerRouter = "getEulerRouterInfo",
  FixedRateOracle = "getFixedRateOracleInfo",
  RateProviderOracle = "getRateProviderOracleInfo",
  OndoOracle = "getOndoOracleInfo",
  PendleUniversalOracle = "getPendleOracleInfo",
}

export const oracleNameToFunction: Record<
  string,
  ContractFunctionName<OracleTypeAbi>
> = {
  ChainlinkOracle: OracleNameFunction.ChainlinkOracle,
  ChainlinkInfrequentOracle: OracleNameFunction.ChainlinkInfrequentOracle,
  ChronicleOracle: OracleNameFunction.ChronicleOracle,
  LidoOracle: OracleNameFunction.LidoOracle,
  LidoFundamentalOracle: OracleNameFunction.LidoOracle,
  PythOracle: OracleNameFunction.PythOracle,
  RedstoneCoreOracle: OracleNameFunction.RedstoneCoreOracle,
  RedstoneClasicOracle: OracleNameFunction.ChainlinkOracle,
  UniswapV3Oracle: OracleNameFunction.UniswapV3Oracle,
  CrossAdapter: OracleNameFunction.CrossAdapter,
  EulerRouter: OracleNameFunction.EulerRouter,
  FixedRateOracle: OracleNameFunction.FixedRateOracle,
  RateProviderOracle: OracleNameFunction.RateProviderOracle,
  OndoOracle: OracleNameFunction.OndoOracle,
  PendleUniversalOracle: OracleNameFunction.PendleUniversalOracle,
} as const

export type OracleTypeAbi = typeof contractBook.oracleTypes.abi
export type OracleName = keyof typeof oracleNameToFunction
export type OracleType<
  functionName extends ContractFunctionName<OracleTypeAbi>,
> = ContractFunctionResult<OracleTypeAbi, functionName>

export type OracleDetailedInfo = {
  name: OracleName
  oracleInfo: Hex
  oracle: Address
  vault: Address
}

export type PushOracles = {
  pyth: (OracleType<"getPythOracleInfo"> & { oracle: Address })[]
  redstone: (OracleType<"getRedstoneCoreOracleInfo"> & { oracle: Address })[]
}

export type OracleTypes = ContractFunctionResult<OracleTypeAbi> & {
  oracle: Address
  vault: Address
}

export type OracleDecoded = {
  base: Address
  quote: Address
  name: string
  oracle: Address
  assets: readonly Address[] | undefined
}

export type BaseOracleNamesAndQuotes = {
  names: string[]
  oracles: Record<Address, OracleDecoded[]>
  baseVault: Address
}
